<template>
  <div class="cert-row">
    <div class="header">
      <div class="meta">
        <span class="date">{{ formatDate(certification.certifiedAt) }}</span>
        <span class="arrow">→</span>
        <span class="date">{{ formatDate(certification.expiresAt) }}</span>
        <certification-status-badge v-if="derivedStatus" :status="derivedStatus" />
      </div>
      <div class="actions" v-if="canManage">
        <icon-button icon="el-icon-edit" @click.stop.prevent="$emit('edit', certification)" />
        <icon-button icon="el-icon-close" @click.stop.prevent="$emit('delete', certification)" />
      </div>
    </div>

    <div v-if="certification.performedByName" class="performer">
      Performed by {{ certification.performedByName }}<span v-if="certification.performedByPhone"> · {{ certification.performedByPhone }}</span>
    </div>

    <div v-if="certification.documentFile" class="preview-toggle">
      <el-button type="text" size="mini" @click="showPreview = !showPreview">
        {{ showPreview ? 'Hide PDF' : 'Show PDF' }}
      </el-button>
    </div>

    <pdf-preview
      v-if="showPreview && certification.documentFile"
      :file="certification.documentFile"
      :height="350" />
  </div>
</template>

<script>
import CertificationStatusBadge from './CertificationStatusBadge'
import PdfPreview from './PdfPreview'

export default {
  name: 'CertificationRow',
  components: { CertificationStatusBadge, PdfPreview },
  props: {
    certification: {
      type: Object,
      required: true
    },
    canManage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showPreview: false
    }
  },
  computed: {
    derivedStatus () {
      if (!this.certification.expiresAt) return null
      const expires = new Date(this.certification.expiresAt).getTime()
      const now = Date.now()
      if (expires <= now) return 'Expired'
      const days = (expires - now) / (1000 * 60 * 60 * 24)
      if (days <= 30) return 'ExpiringSoon'
      return 'Current'
    }
  },
  methods: {
    formatDate (value) {
      if (!value) return '—'
      const d = new Date(value)
      if (isNaN(d.getTime())) return value
      return d.toLocaleDateString()
    }
  }
}
</script>

<style lang="scss" scoped>
  .cert-row {
    padding: 12px 0;
    border-bottom: 1px solid $border;

    &:last-child {
      border-bottom: none;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .meta {
    display: flex;
    align-items: center;
    gap: 8px;

    > * + * {
      margin-left: 8px;
    }

    .date {
      font-weight: 500;
      font-size: 13px;
    }

    .arrow {
      color: $text-light;
    }
  }

  .performer {
    margin-top: 4px;
    font-size: 12px;
    color: $text-light;
  }

  .preview-toggle {
    margin-top: 4px;
  }

  .actions {
    display: flex;
    gap: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Certification/CertificationRow.vue